import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER } from '@angular/material/tooltip';
import { PublicService } from 'src/app/core/services/public.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-query-dialog',
  templateUrl: './add-query-dialog.component.html',
  styleUrls: ['./add-query-dialog.component.scss'],
  viewProviders: [MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER],
})
export class AddQueryDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddQueryDialogComponent>,
    private fb: FormBuilder,
    private publicService: PublicService,
  ) { }

  queryForm = new FormGroup({
    id: this.fb.control('', Validators.required),
    providerRegistrationApprovalId: this.fb.control('', Validators.required),
    updatedBy: this.fb.control('', Validators.required),
    queryResponse: this.fb.control('', Validators.required),
    queryRaised: this.fb.control('', Validators.required),
    doc: this.fb.control('')
  });

  proproviderRegistrationApprovalId: any;

  ngOnInit(): void {
    let query = this.data.query;
    if (query) {
      this.queryForm['controls'].id.setValue(query.id)
      this.queryForm['controls'].providerRegistrationApprovalId.setValue(query.providerRegistrationApprovalId)
      this.queryForm['controls'].updatedBy.setValue(query.updatedBy)
      this.queryForm['controls'].queryResponse.setValue(query.queryResponse)
      this.queryForm['controls'].queryRaised.setValue(query.queryRaised)
    }
  }

  addQuery() {

  }

  singleDocument: any;
  documentBucket: any = [];

  addQueryDocument(event: any): void {
    this.documentBucket = [];
    if (event.target.files && event.target.files.length) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          if (!this.documentBucket.some((doc: any) => doc.fileName === file.name)) {
            this.documentBucket.push({
              name: file.name,
              file: reader.result,
              extension: file.name.split('.').pop().toLowerCase()
            });
          }
        };
      }
    }
  }

  submitQuery() {
    Swal.showLoading()
    let submitData = this.queryForm.getRawValue();
    submitData.doc = this.documentBucket[0];
    this.publicService.responseQuery(submitData).subscribe(
      (res: any) => {
        Swal.close()
        Swal.fire('', 'Responended Successfully', 'success');
        this.dialogRef.close('success')
      },
      (err: any) => {
        Swal.close()
        if (err && err.error && err.error.message) {
          Swal.fire('', err.error.message, 'error');
        } else if (err && err.message) {
          Swal.fire('', err.message, 'error');
        } else {
          Swal.fire('', 'Something went wrong', 'error');
        }
      }
    )
  }

  removeQueryDocument() {
    this.documentBucket = [];
  }

}
